import i18next from 'i18next';
import StatusPill from '../../../components/Common/ListParts/StatusPill';

/**
 * Tom do selo por situação do processamento. Falha e recusa pedem investigação; ignorado é
 * um descarte sem erro (evento sem efeito, fora de ordem), então fica apagado.
 */
export const WEBHOOK_STATUS_TONES = {
    PROCESSED: 'paid',
    IGNORED: 'muted',
    FAILED: 'danger',
    UNAUTHORIZED: 'danger',
    RECEIVED: 'info'
};

/** Nome do evento em português. Um evento novo do Asaas, ainda sem tradução, aparece pelo código. */
export const webhookEventLabel = (event) => event
    ? i18next.t(`saas_webhook.events.${event}`, { defaultValue: event })
    : '-';

/** Selo da situação, no mesmo padrão das demais listagens. */
export const WebhookStatusPill = ({ status }) => status
    ? <StatusPill tone={WEBHOOK_STATUS_TONES[status] || 'muted'}>{i18next.t(`saas_webhook.statuses.${status}`, { defaultValue: status })}</StatusPill>
    : '-';

/**
 * O que aconteceu com o evento: o resultado gravado pelo processamento, o erro técnico
 * quando não há resultado, ou o aviso de que o ignorado é anterior ao registro do motivo.
 */
export const webhookResult = (row) => {
    if (row?.processingDetail) {
        return row.processingDetail;
    }
    if (row?.errorMessage) {
        return row.errorMessage;
    }
    return row?.processingStatus === 'IGNORED' ? i18next.t('saas_webhook.details.no_reason') : '-';
};

/** Eventos de assinatura trazem o próximo vencimento dela, não o de uma fatura. */
export const isSubscriptionEvent = (event) => Boolean(event?.startsWith('SUBSCRIPTION_'));

// As colunas calculadas (empresa, valor, vencimento, resultado) não são atributos do evento,
// então não ordenam: o backend monta o ORDER BY pelo nome do campo.
export const SaaSWebhookColumns = [
    { headerName: 'saas_webhook.received_at', field: 'createdAt', type: 'datetime', width: '175' },
    {
        headerName: 'company',
        field: 'companyName',
        valueGetter: (params) => params.data?.companyName || '-',
        sortable: false,
        width: '210'
    },
    {
        headerName: 'saas_webhook.event',
        field: 'event',
        valueGetter: (params) => webhookEventLabel(params.data?.event),
        width: '210'
    },
    {
        headerName: 'status',
        field: 'processingStatus',
        cellRenderer: (params) => <WebhookStatusPill status={params.data?.processingStatus} />,
        width: '135'
    },
    { headerName: 'value', field: 'value', type: 'currency', sortable: false, width: '130' },
    { headerName: 'saas_webhook.due_date', field: 'dueDate', type: 'date', sortable: false, width: '135' },
    {
        headerName: 'saas_webhook.result',
        field: 'processingDetail',
        valueGetter: (params) => webhookResult(params.data),
        sortable: false,
        width: '460'
    },
];
